module.exports = __webpack_public_path__ + "img/IMG_2729_L_Foamcore_MockedUp.9d71ce3c.jpg";